import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { PageSkeleton } from "../ui/Skeleton";

// react-router v7 guard. Used as <Route element={<AdminRoute><X/></AdminRoute>}/>.
// While the session is still loading, `fallback` holds the page's space so
// the footer doesn't jump; pass a skeleton shaped like the guarded page.
const AdminRoute = ({ children, fallback = <PageSkeleton /> }) => {
  const { user, isAuthenticated, loading } = useSelector((state) => state.user);
  const location = useLocation();

  if (loading) return fallback;
  if (user && user.role === "admin" && isAuthenticated === true) {
    return children;
  }
  return <Navigate to="/" replace state={{ from: location }} />;
};

export default AdminRoute;
